import { render } from "./LoderWait.vue?vue&type=template&id=034738a4&scoped=true"
import script from "./LoderWait.vue?vue&type=script&lang=js"
export * from "./LoderWait.vue?vue&type=script&lang=js"

import "./LoderWait.vue?vue&type=style&index=0&id=034738a4&scoped=true&lang=css"

import exportComponent from "/home/tarun/Downloads/sunlight replica  vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-034738a4"]])

export default __exports__